import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Container, DropContainer, UploadMessage, ErrorMessageContainer, ErrorMessage } from './styles';

class UploadImage extends Component {
  state = {
    dropReject: [],
  }
  renderDragMessage = (isDragActive, isDragReject) => {
    if (!isDragActive) {
      return <UploadMessage>Arraste as imagens aqui ou clique...</UploadMessage>
    }

    if (isDragReject) {
      return <UploadMessage type="error">Tipo de arquivo não suportado!</UploadMessage>
    }
    return <UploadMessage type="success">Solte as imagens aqui!</UploadMessage>
  }

  onDropRejected = (data) => {
    if (data && data.length) {
      this.setState({
        dropReject: data
      })
    }

    setTimeout(() => {
      this.setState({ dropReject: [] });
    }, 5000);
  }

  render() {
    const { dropReject } = this.state;
    const { onUpload } = this.props;
    return (
      <Dropzone accept="image/png,image/jpeg" maxSize={490000} maxFiles={3} onDropAccepted={onUpload} onDropRejected={(data) => this.onDropRejected(data)} >
        { ({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <Container>
            <DropContainer
              {...getRootProps()}
              isDragActive={isDragActive}
              isDragReject={isDragReject}
            >
              <input {...getInputProps()} />
              {this.renderDragMessage(isDragActive, isDragReject)}
            </DropContainer>
            <ErrorMessageContainer>
              {dropReject.length ?
                <ErrorMessage type="error">
                  {dropReject.length} {dropReject.length > 1 ?
                    'arquivos não suportados ou tamanho das imagens muito grande! ' :
                    'arquivo não suportado ou tamanho da imagem muito grande '}
                </ErrorMessage>
                : <ErrorMessage>*** No máximo 3 imagens!</ErrorMessage>}
            </ErrorMessageContainer>
          </Container>
        )
        }
      </Dropzone>
    );
  }
}

export default UploadImage;